import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, apiErrorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function FinancingModal({ open, onOpenChange }) {
  const { user } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", {
        email: user ? undefined : form.email,
        first_name: user ? undefined : form.name,
        phone: form.phone,
        message: form.message,
        source: "financing",
        url: window.location.href,
      });
      toast.success("Получихме заявката ви. Ще се свържем с вас скоро.");
      onOpenChange(false);
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(apiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md border-t-4 border-t-[#C47A35]" data-testid="financing-modal">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-[#10243A]">Финансиране на имот</DialogTitle>
          <DialogDescription className="text-[#66717B]">
            Оставете данните си и екипът на Investivo ще се свърже с вас за безплатна консултация по финансиране.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3 pt-2">
          {!user && (
            <>
              <Input required placeholder="Име" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="financing-name-input" />
              <Input type="email" required placeholder="Имейл" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="financing-email-input" />
            </>
          )}
          {user && <p className="text-sm text-[#66717B]">Ще използваме данните на профила ви: {user.email}</p>}
          <Input required placeholder="Телефон" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="financing-phone-input" />
          <Textarea placeholder="Кратко описание на нуждата от финансиране (по избор)" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="financing-message-input" />
          <Button type="submit" disabled={loading} className="w-full bg-[#10243A] hover:bg-[#C47A35] text-white transition-colors" data-testid="financing-submit-btn">
            {loading ? "Изпращане..." : "Изпрати заявка"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
